import React from "react";
import Link from "next/link";
import styles from "./video_meta.module.scss";

const VideoMeta = () => {
  return (
    <div className={styles.meta}>
      <div className={styles.author}>
        <Link legacyBehavior href="#">
          <a>admin</a>
        </Link>
      </div>
      <div className={styles.dot}></div>
      <div className={styles.date}>January 14, 2020</div>
      <div className={styles.dot}></div>
      <div className={styles.view}>1.369M views</div>
    </div>
  );
};

export default VideoMeta;
